module.exports = __webpack_public_path__ + "img/cadastro-pedale.bd623e13.jpg";